<div class="iconContainer">
  <i [class]="checkboxStyle(viewModel.onGetValue | async)" (click)="onClick()"></i>
</div>
